import { productMessaging } from '../../../config/messaging';
import type { ReactFlowInstance } from 'reactflow';
import { OutputMetricsPanel } from './OutputMetricsPanel';
import { WorkspaceViewFrame } from './WorkspaceViewFrame';

interface ResultsViewProps {
  reactFlowInstance: ReactFlowInstance | null;
  onHoverMetric?: (nodeId: string | null) => void;
}

export const ResultsView = ({ reactFlowInstance, onHoverMetric }: ResultsViewProps) => {
  return (
    <WorkspaceViewFrame
      eyebrow="Results"
      title="Output results"
      description={productMessaging.emptyStates.resultsBody}
    >
      <div className="workspace-results-layout">
        <div className="workspace-results-panel">
          <OutputMetricsPanel reactFlowInstance={reactFlowInstance} onHoverMetric={onHoverMetric} />
        </div>
      </div>
    </WorkspaceViewFrame>
  );
};
